import { render, staticRenderFns } from "./ConfirmedAccount.vue?vue&type=template&id=07acf5e6&scoped=true&"
import script from "./ConfirmedAccount.vue?vue&type=script&lang=js&"
export * from "./ConfirmedAccount.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmedAccount.vue?vue&type=style&index=0&id=07acf5e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07acf5e6",
  null
  
)

export default component.exports